module.exports = [
    { text: "Month Over Month", value: "month" },
];